import { profileById } from "../lib/lookups";
import type { BoardStore } from "../stores/board";
import type { Role } from "../lib/types";

const MESSAGES: Record<Role, string> = {
  Owner: "Top-level operations view. Throughput, blockers, dispatch readiness.",
  Scheduler: "Schedule and dispatch are primary. Click any block to edit. Use New booking to test conflict detection.",
  "Flight Instructor": "Your bookings, your students. Mark dispatch readiness from the board.",
  "Ground Instructor": "Ground school sessions and theory program oversight.",
  Student: "Your training timeline and what's next.",
};

function boardStore(): BoardStore {
  return (window as unknown as { Alpine: { store(name: string): BoardStore } }).Alpine.store("board");
}

export function demoBannerAlpine() {
  return {
    dateLabel:
      "SKYHAWK AVIATION ACADEMY · VOBG · DGCA-APPROVED FTO · " +
      new Date()
        .toLocaleDateString("en-IN", { weekday: "short", month: "short", day: "numeric" })
        .toUpperCase(),
    currentName(): string {
      const board = boardStore();
      const id = board.currentUserId();
      return profileById(board.lookups.profiles, id)?.name ?? "";
    },
    message(): string {
      return MESSAGES[boardStore().role];
    },
  };
}
